module.exports = __webpack_public_path__ + "img/night-top-bg_in.d19d990f.png";